import React, { useState, useRef } from "react"
import { Link } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"

const sectionStyle = {
  border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px",
  marginBottom: "16px", background: "#fff"
}
const sectionTitle = (icon, title) => (
  <h6 style={{ color: "#6366f1", marginBottom: "14px", fontSize: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
    <i className={`fas ${icon}`} style={{ fontSize: "13px" }}></i>{title}
  </h6>
)

const AddTransporter = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const response = await api.post("create-transporter", values)
      if (response.data.success === true || response.data.message) {
        formRef.current.reset()
        setSubmitted(true)
      }
    } catch (error) {
      // Handled by global interceptor
    }
    setLoading(false)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Add Transporter</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/transporters" className="dashBtn">
                <i className="fas fa-chevron-left"></i> <b>Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm style={{ position: "relative" }} ref={formRef} className="form-horizontal"
            onValidSubmit={(e, v) => handleValidSubmit(e, v)}>

            <div style={sectionStyle}>
              {sectionTitle("fa-truck", "Transporter Information")}
              <Row>
                <Col md={6}><div className="mb-3"><AvField name="transporterName" label="Transporter Name *" type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="phone" label="Phone" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="email" label="Email" type="email" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="address" label="Address" type="textarea" rows="2" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="gst" label="GST" type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="pan" label="PAN" type="text" /></div></Col>
              </Row>
            </div>

            <div style={sectionStyle}>
              {sectionTitle("fa-cog", "Settings")}
              <Row>
                <Col md={6}><div className="mb-3">
                  <AvRadioGroup inline name="paymentMode" label="Payment Mode *" required value="cash">
                    <AvRadio label="Cash" value="cash" /><AvRadio label="Account" value="account" />
                  </AvRadioGroup>
                </div></Col>
                <Col md={6}><div className="mb-3">
                  <AvRadioGroup inline name="tdsApplicable" label="TDS Applicable for Billing *" required value="0">
                    <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
                  </AvRadioGroup>
                </div></Col>
              </Row>
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success"><strong>Transporter is Added!</strong></UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (
                    <><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Adding...</span></>
                  ) : (
                    <span>Add Transporter</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddTransporter
